const _auto = "auto"
const _scroll = "scroll-position"
const _contents = "contents"
const _transform = "transform"
const config = { "auto": _auto, "scroll": _scroll, "contents": _contents, "transform": _transform,  }
export { config as default, _auto, _scroll, _contents, _transform }